import { BrowserRouter } from 'react-router-dom';
import { AppRoutes } from './router';
import Sidebar from './components/feature/Sidebar';
import Header from './components/feature/Header';
import { useLocation } from 'react-router-dom';

function AppContent() {
  const location = useLocation();

  const getTitleAndSubtitle = () => {
    switch (location.pathname) {
      case '/':
        return { title: '源文档管理', subtitle: '上传和管理制度文档，配置解析域并关联版本' };
      case '/extraction':
        return { title: '规则抽取审核', subtitle: '审核AI抽取的规则，支持确认、编辑、拆分、合并操作' };
      case '/agents':
        return { title: '智能体接入', subtitle: '管理智能体接入配置，查看调用统计和日志' };
      case '/statistics':
        return { title: '数据统计', subtitle: '查看系统整体数据和使用趋势分析' };
      case '/applications':
        return { title: '应用中心', subtitle: '管理已接入的智能体应用，查看运行状态和调用数据' };
      default:
        return { title: '规则智能引擎', subtitle: '' };
    }
  };

  const { title, subtitle } = getTitleAndSubtitle();

  return (
    <div className="flex h-screen bg-slate-100">
      <Sidebar />
      <div className="flex-1 flex flex-col overflow-hidden">
        <Header title={title} subtitle={subtitle} />
        <main className="flex-1 overflow-auto">
          <AppRoutes />
        </main>
      </div>
    </div>
  );
}

export default function App() {
  return (
    <BrowserRouter basename={__BASE_PATH__}>
      <AppContent />
    </BrowserRouter>
  );
}
